import React from "react";

export default function CheckIcon({ className = "lpm-check-icon", strokeWidth = 2, stroke = "#fff" }) {
  return (
    <svg className={className} viewBox="0 0 24 24" strokeWidth={strokeWidth} stroke={stroke} fill="none">
      <polyline points="20 6 9 17 4 12" />
    </svg>
  );
}
